import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface RequestConvertQuoteParameter extends ApiParameter {
    OrderNumber: string;
    Message: string;
    PurchaseOrderNumber: string;
    DeliveryMethod: string;
    DateNeeded: string;
}
const RequestConvertQuoteUrl = "/api/v2/QuoteToOrder/SendEmail";

export function requestConvertQuoteSendEmailAPI(parameter: RequestConvertQuoteParameter) {
    return post<RequestConvertQuoteParameter>(`${RequestConvertQuoteUrl}`, parameter);
}